<template>
	<a class="rmp-link-text d-inline-flex align-center"
	   :class="{ 'd-flex': !inline }"
	   :style="{ color, width: inline ? 'fit-content' : undefined }"
	   :href="resolvedHref"
	   :target="blank ? '_blank' : '_self'"
	   @click="handleClick">
		<rmp-icon v-if="icon" :src="icon" :width="icoSize" :height="icoSize" :class="icoMargin"/>
		<rmp-text tag="span" :type="type" :weight="weight" :size="size" :class="{ 'text-decoration-underline': underline }">
			<slot>{{ text }}</slot>
		</rmp-text>
	</a>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRouter } from "vue-router/composables";
import { RawLocation } from "vue-router/types/router";
import RmpIcon from "@rmp/core/components/icon/RmpIcon.vue";
import RmpText from "@rmp/core/components/typography/RmpText.vue";
import type { RmpTextType, RmpTextSize } from "@rmp/core/components/typography/types";

interface Props {
	to?: RawLocation;
	href?: string;
	text?: string;
	color?: string;
	type?: RmpTextType;
	size?: RmpTextSize;
	weight?: number;
	icon?: string;
	icoSize?: string;
	icoMargin?: string;
	underline?: boolean;
	inline?: boolean;
	blank?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
	to: undefined,
	href: undefined,
	text: undefined,
	color: undefined,
	type: "body",
	size: "medium",
	icon: undefined,
	icoSize: undefined,
	icoMargin: "mr-2"
});

const emit = defineEmits<{
	(e: "click", event: MouseEvent): void;
}>();

const router = useRouter();

const resolvedHref = computed(() => props.to ? router.resolve(props.to).href : props.href);

const handleClick = (event: MouseEvent) => {
	emit("click", event);
	
	if(!props.to || props.blank || event.defaultPrevented) return;
	
	event.preventDefault();
	router.push(props.to);
};
</script>
